import { useTranslations } from 'next-intl'
import { pushModal } from '@/components/modals'

export const useAIMedia = () => {
  const t = useTranslations('ai-chat.ai-coding')

  const aiMedia = async (data: { model: string; inputs: any }) => {
    try {
      const response = await fetch('/api/media', {
        method: 'POST',
        body: JSON.stringify(data),
      })

      if (response.status !== 200) {
        const error = await response.json()
        console.log('error:', error)
        const errorMessage = error.message?.toLowerCase()

        if (errorMessage?.includes('insufficient coins')) {
          pushModal('PricingModal', {
            type: 'out_of_credit',
          })
        }
        return
      }

      const res = await response.json()
      return res
    } catch (error) {
      console.log('error', error)
    } finally {
    }
  }

  return { aiMedia }
}
